import { Outlet, createFileRoute } from "@tanstack/react-router";
import { User03 } from "@untitled-ui/icons-react";

import TableSkeleton from "@/components/loadings/skeleton/TableSkeleton";
import { type ChildRouteContext } from "@/root";
import { redirectIfModuleDisabled } from "@/utils/permissions";

export const Route = createFileRoute("/_panel/_profile")({
  component: Component,
  beforeLoad: ({ context }) => {
    redirectIfModuleDisabled("profile", context.tenant.modules);

    return {
      title: () => context.t("Profile", { ns: "profile.shared" }),
      crumb: [
        {
          Icon: User03,
        },
      ],
    } satisfies ChildRouteContext;
  },
  pendingComponent: TableSkeleton,
});

function Component() {
  return <Outlet />;
}
